import React from "react";

import { faExternalLinkAlt } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { defineMessages, useIntl } from "react-intl";
import { Link } from "react-router-dom";

import { Alert } from "@mapmycustomers/ui";

import Path from "@app/enum/Path";
import SettingPath from "@app/enum/settings/SettingPath";

import styles from "./FieldRequiredAlert.module.scss";

const messages = defineMessages({
  action: {
    id: "settings.manageFields.createEditPane.fieldRequiredAlert.requiredHint.action",
    defaultMessage: "Go to Layouts",
    description: "Settings Custom field - required location action label",
  },
  createFieldRequiredHint: {
    id: "settings.manageFields.createEditPane.createForm.fieldRequiredAlert.requiredHint.title",
    defaultMessage: "You can mark this field “required” in <link>Layouts</link> after creating it",
    description: "Settings Unique Custom field - required title",
  },
  requiredHint: {
    id: "settings.manageFields.createEditPane.fieldRequiredAlert.requiredHint.label",
    defaultMessage: "Looking to mark this required?",
    description: "Settings Custom field - required location hint",
  },
  uniqueCustomFieldAlert: {
    id: "settings.manageFields.createEditPane.fieldRequiredAlert.uniqueCustomField.description",
    defaultMessage:
      "If this field is required and its values must be unique, users will be prevented from adding records <b>in bulk</b> with Lead Finder and MMC Email.",
    description: "Settings Unique Custom field - required description",
  },
});

interface Props {
  isCreateForm?: boolean;
  isUnique?: boolean;
}

const FieldRequiredAlert: React.FC<Props> = ({ isCreateForm, isUnique }) => {
  const intl = useIntl();
  return (
    <Alert
      action={
        !isCreateForm && (
          <Link
            rel="noopener noreferrer"
            target="_blank"
            to={`${Path.SETTINGS}/${SettingPath.FORMS_CREATE}`}
          >
            {intl.formatMessage(messages.action)}
            <FontAwesomeIcon className={styles.iconLink} icon={faExternalLinkAlt} />
          </Link>
        )
      }
      className={styles.requiredAlert}
      description={
        isUnique
          ? intl.formatMessage(messages.uniqueCustomFieldAlert, { b: (text) => <b>{text}</b> })
          : undefined
      }
      message={intl.formatMessage(
        isCreateForm ? messages.createFieldRequiredHint : messages.requiredHint,
        {
          link: (linkText: string) => (
            <Link
              rel="noopener noreferrer"
              target="_blank"
              to={`${Path.SETTINGS}/${SettingPath.FORMS_CREATE}`}
            >
              {linkText}
            </Link>
          ),
        }
      )}
      type="info"
    />
  );
};

export default FieldRequiredAlert;
